export const eventsWithoutTI = [
  223240, 223487, 223439, 223534, 223488, 223535, 223546, 258940, 258942,
  224701,
];

export const eventWithTIDeactivated = [];
